import { render, staticRenderFns } from "./change-price.vue?vue&type=template&id=b163251e&scoped=true&"
import script from "./change-price.vue?vue&type=script&lang=js&"
export * from "./change-price.vue?vue&type=script&lang=js&"
import style0 from "./change-price.vue?vue&type=style&index=0&id=b163251e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b163251e",
  null
  
)

export default component.exports